import * as tslib_1 from "tslib";
import { Vector2 } from "../Maths/math";
import { Texture } from "../Materials/Textures/texture";
import { PostProcess } from "./postProcess";
import "../Shaders/vrDistortionCorrection.fragment";
/**
 * VRDistortionCorrectionPostProcess used for mobile VR
 */

var VRDistortionCorrectionPostProcess =
/** @class */
function (_super) {
  tslib_1.__extends(VRDistortionCorrectionPostProcess, _super);
  /**
   * Initializes the VRDistortionCorrectionPostProcess
   * @param name The name of the effect.
   * @param camera The camera to apply the render pass to.
   * @param isRightEye If this is for the right eye distortion
   * @param vrMetrics All the required metrics for the VR camera
   */


  function VRDistortionCorrectionPostProcess(name, camera, isRightEye, vrMetrics) {
    var _this = _super.call(this, name, "vrDistortionCorrection", ['LensCenter', 'Scale', 'ScaleIn', 'HmdWarpParam'], null, vrMetrics.postProcessScaleFactor, camera, Texture.BILINEAR_SAMPLINGMODE) || this;

    _this._isRightEye = isRightEye;
    _this._distortionFactors = vrMetrics.distortionK;
    _this._postProcessScaleFactor = vrMetrics.postProcessScaleFactor;
    _this._lensCenterOffset = vrMetrics.lensCenterOffset;
    _this.adaptScaleToCurrentViewport = true;

    _this.onSizeChangedObservable.add(function () {
      _this._scaleIn = new Vector2(2, 2 / _this.aspectRatio);
      _this._scaleFactor = new Vector2(.5 * (1 / _this._postProcessScaleFactor), .5 * (1 / _this._postProcessScaleFactor) * _this.aspectRatio);
      _this._lensCenter = new Vector2(_this._isRightEye ? 0.5 - _this._lensCenterOffset * 0.5 : 0.5 + _this._lensCenterOffset * 0.5, 0.5);
    });

    _this.onApplyObservable.add(function (effect) {
      effect.setFloat2("LensCenter", _this._lensCenter.x, _this._lensCenter.y);
      effect.setFloat2("Scale", _this._scaleFactor.x, _this._scaleFactor.y);
      effect.setFloat2("ScaleIn", _this._scaleIn.x, _this._scaleIn.y);
      effect.setFloat4("HmdWarpParam", _this._distortionFactors[0], _this._distortionFactors[1], _this._distortionFactors[2], _this._distortionFactors[3]);
    });

    return _this;
  }

  return VRDistortionCorrectionPostProcess;
}(PostProcess);

export { VRDistortionCorrectionPostProcess };